(ns teamoesterreich.firebase.firebase

  (:require
    [goog.object :as g]
    [teamoesterreich.setup :as setup]
    [teamoesterreich.util.log :as log]
    ))

(defonce FIREBASE_CONFIG (:firebase-config setup/config))

(log/debug "FB App Initialized =" FIREBASE_CONFIG)

(defonce fb-conn js/firebase)


(def app ((g/get fb-conn "initializeApp") (clj->js FIREBASE_CONFIG)))